import React from 'react';
import { Linkedin, X, Instagram } from 'lucide-react';
import LogoIcon from '../../assets/icons/logo3.png';

import './Footer.css';

const footerLinks = {
  Company: [
    { label: 'Home', href: '/' },
    { label: 'Upload resume', href: '/upload' },
    { label: 'Contact', href: '/contact' },
    { label: 'About', href: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className='site-footer'>
      <div className='footer-top'>
        <div className='footer-logo'>
          <img src={LogoIcon} alt='Company logo' />
        </div>

        {Object.entries(footerLinks).map(([section, links]) => (
          <div key={section} className='footer-column'>
            <h4>{section}</h4>
            <ul>
              {links.map(link => (
                <li key={link.href}>
                  <a href={link.href}>{link.label}</a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className='footer-bottom'>
        <div className='attribution-text' style={{ fontSize: '10px' }}>Icons by Freepik, FlatIcon, Google.</div>

        <div className='social-icons'>
          <a href='https://instagram.com/resycle.me' aria-label='Instagram'>
            <Instagram size={20} />
          </a>
        </div>
      </div>
    </footer>
  );
}


